import React from 'react';
import PropTypes from 'prop-types';
import { Trans } from '@lingui/react';

// Components
import GenericModal, { MODAL_TYPE } from '../generic-modal/generic-modal';
import Button, { BUTTON_STYLES } from '../button/button';

function StudentChangeGroup({ closeHandler, applyHandler, changeGroupErrorMessage, productId }) {
    productId = productId || 1;
    return (
        <GenericModal
            title={<Trans id="Change Group - title" />}
            type={MODAL_TYPE.floating}
            parentClasses="modal--small"
            closeHandler={closeHandler}>
            <Trans id={`Change Group - message - product ${productId}`}>
                <p className="modal__message">
                    <strong>1</strong> 0
                </p>
            </Trans>
            <div className="form__row form__row--buttons">
                <Button
                    buttonStyle={BUTTON_STYLES.text}
                    callback={applyHandler}
                    visibleText={<Trans id="Change Group - button" />}
                />
            </div>
            {
                changeGroupErrorMessage ? (
                    <div className="form__row">
                        <p className="form__error-message form__error-message--bottom">
                            {changeGroupErrorMessage}
                        </p>
                    </div>
                ) : ''
            }
        </GenericModal>
    );
}

StudentChangeGroup.propTypes = {
    closeHandler: PropTypes.func,
    applyHandler: PropTypes.func,
    changeGroupErrorMessage: PropTypes.string,
    productId: PropTypes.string
};

export default StudentChangeGroup;



// WEBPACK FOOTER //
// ./components/student-change-group/student-change-group.js